import { render, staticRenderFns } from "./SiteMenu.vue?vue&type=template&id=044a7c04&"
import script from "./SiteMenu.vue?vue&type=script&lang=js&"
export * from "./SiteMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports